define(function(require){
    'use strict';

    var _ = require('underscore');
    var Marionette  = require('marionette');
    var I18n        = require('i18n!nls/main');

    return Backbone.Collection.extend({
        parse: function(response, options){
            return (typeof response.result != 'undefined') ? response.result.data : response;
        },

        comparator: function(model){
            if(typeof model != 'undefined'){
                return model.get('sort');
            }else{
                return model.cid;
            }
        },


        save: function(options) {
            var that  = this;
            var valid = true;

            _.each(this.models, function(model, i){
                if(!model.isValid(true)){
                    valid = false;
                }
            });

            if(valid){
                this.sync('update', this, options || {}).done(function(responseData) {
                    that.set(that.parse(responseData, options), options);
                    that.trigger('sync');
                    
                    app.message.success( responseData.message || I18n.Saved );
                });
            }else{
                app.curPage.showPanelBtns(false);
                app.message.error('Ошибка валидации');
            }

            return that;
        }

    });

});
